/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { StateObj } from 'data/state-object';
import { StateType } from 'types/api-data';

import { cn } from '@/lib/utils';

import { Logo } from './logo';

type CardProps = Readonly<{
  children: React.ReactNode;
  type: string;
  autoDetected?: boolean;
  state?: StateType;
  className?: string;
  disableHover?: boolean;
}>;

export const Card = ({
  children,
  type,
  autoDetected,
  state,
  className,
  disableHover = false,
}: CardProps) => {
  const stateObj = StateObj();
  return (
    <div
      className={cn(
        'flex h-full items-center gap-x-3 overflow-hidden rounded-lg border border-line-secondary bg-canvas-background-primary p-4 shadow-[0px_0px_12px_0px_#00000040]',
        disableHover
          ? ''
          : 'hover:border-form-control-border-focus hover:bg-card-02 hover:shadow-[2px_8px_16px_0px_rgba(0,0,0,0.32)]',
        className
      )}
    >
      <Logo type={type} autoDetected={autoDetected} />
      <div className="flex flex-col gap-1.5">
        {state && state !== 'supported' && (
          <div
            style={stateObj[state].color}
            className="flex h-5 w-fit items-center justify-center gap-x-1 rounded pl-1 pr-1.5 text-[11px] leading-none"
          >
            <span>{stateObj[state]?.img}</span>
            <span>{stateObj[state]?.name}</span>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
